"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Asset Allocation"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,17.5H21V12a.5.5,0,0,0-.5-.5H12v-6h7.5A.5.5,0,0,0,20,5V1a.5.5,0,0,0-.5-.5H4.5A.5.5,0,0,0,4,1V5a.5.5,0,0,0,.5.5H11v6H3.5A.5.5,0,0,0,3,12v5.5H.5A.5.5,0,0,0,0,18v5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,6,23V18a.5.5,0,0,0-.5-.5H4v-5h7v5H9.5A.5.5,0,0,0,9,18v5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,15,23V18a.5.5,0,0,0-.5-.5H12v-5h8v5H18.5a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,24,23V18A.5.5,0,0,0,23.5,17.5Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;